import Gallery from '@jetshop/ui/Gallery/Gallery';
import Badges from '@jetshop/ui/ProductList/Badges';
import React from 'react';
import { styled } from 'linaria/react';
import { useSwitchToVariantImage } from '@jetshop/core/hooks/Product';
import Image from '@jetshop/ui/Image/Image';
import { theme } from '../../Theme';

const Wrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  ${theme.below.sm} {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

const ImageWrapper = styled('div')`
  width: calc(50% - 2px);
  ${theme.below.sm} {
    width: 90%;
    flex-shrink: 0;
  }
  img {
    object-fit: cover !important;
  }
`;

export default function ImageContainer({
  images,
  badges,
  variant,
  children,
  ...rest
}) {
  const galleryRef = React.createRef();
  // Enable switching gallery to image of selected variant
  useSwitchToVariantImage({
    galleryImages: images,
    galleryRef,
    variant
  });

  return (
    <>
      <Wrapper>
        {images.map((image, index) => (
          <ImageWrapper key={index}>
            <Image src={image.url} aspect={'7:10'} alt={image.alt} />
          </ImageWrapper>
        ))}
      </Wrapper>
      {children}
      <Badges badges={badges} />
    </>
  );
}
